<template>

	<div class="onboarding swipe-wrap" @click="onNext()">
		<div class="swipe-top" :class="{ 'hide' : num!=0, 'show':num==1 }">
			<img src="../../assets/icon/swipe-up.svg" alt="swipe-up" />
		</div>
		<div class="swipe-bottom" :class="{ 'hide' : num!=0, 'show':num==2 }">
			<img src="../../assets/icon/swipe-down.svg" alt="swipe-down" />
		</div>
	</div>

</template>


<script>
	import { EventBus } from '../../main';
    export default {
     	name: "swipe-tut",

        data(){
		    return{
		    	num:0,
		    }
		},

		mounted(){

		},

		methods: {
			onNext() {
				this.num++;
				if(this.num==3) {
					EventBus.$emit('swipetut',true);
					localStorage.setItem('swipetut', true);
				}
			}
		}

    }

</script>

<style type="text/css">

	.onboarding {
	    position: absolute;
	    top: 0;
	    left: 0;
	    background: rgba(40, 81, 125, 0.65);
	    width: 100%;
	    height: 100%;
	    line-height: initial;
	    display: -webkit-box;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: center;
	        -ms-flex-pack: center;
	            justify-content: center;
	    -webkit-box-align: center;
	        -ms-flex-align: center;
	            align-items: center;
    	-webkit-box-orient: vertical;
    	-webkit-box-direction: normal;
    	    -ms-flex-direction: column;
    	        flex-direction: column;
    	z-index: 999;
    	cursor: pointer;
	}

	.onboarding-wrap {
	    width: 100%;
	    -ms-flex-pack: distribute;
	        justify-content: space-around;
	}	

	.swipe-wrap{
	    display: -webkit-box;
	    display: -ms-flexbox;
	    display: flex;
	    -ms-flex-pack: distribute;
	        justify-content: space-around;
	}

	.swipe-top, .swipe-bottom {
	    -webkit-transform: scale(2);
	        -ms-transform: scale(2);
	            transform: scale(2);
	}

	.hide{
		visibility: hidden;
	}

	.show{
		visibility: visible;
	}
</style>